<div class="image-feed-container">
    <image-feed class="image-feed" [imageHeight]="200" [itemsPerRow]="4" (imageClick)="openModal($event)"></image-feed>
</div>